"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 22 22" id=icon-search><path d="M2 9a7 7 0 1114 0A7 7 0 012 9m19.703 11.29l-5.67-5.67-.008-.003A8.954 8.954 0 0018 9a9 9 0 00-9-9 9 9 0 00-9 9 9 9 0 009 9 8.958 8.958 0 005.66-2.007l5.663 5.717c.19.187.445.292.71.29a1 1 0 00.67-1.71"></path></symbol>';
};